module.exports = __webpack_public_path__ + "static/media/02_NFX400A-MPS.44817a4c.png";